import { apiClient } from "../Config/ApiClient";

export const retrieveCurrentPrice = (icode, type, token) => apiClient.get(`/history/price`, { params:{type: type, icode: icode}, headers: { 'Authorization': token } });